/**
 * eventbus
 */

class EventBus {
  constructor() {
    this.events = this.events || {}; // {key:Array} 事件池
  }

  /**
   * @param {String} eventName
   * @param {Function} callback
   */
  $on(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName].push(callback);
    } else {
      this.events[eventName] = [callback];
    }
  }

  /**
   * @param {String} eventName
   * @param {Object} data
   */
  $emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach((callback) => {
        if (callback) callback(data);
      });
    }
  }

  /**
   * @param {String} eventName
   */
  $off(eventName) {
    if (eventName) {
      if (this.events[eventName]) {
        delete this.events[eventName];
      }
    } else {
      this.events = [];
    }
  }
}

const MainBus = new EventBus();

export default MainBus;
